/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WellnessCheckQuestion
 */
export interface WellnessCheckQuestion {
    /**
     * 
     * @type {string}
     * @memberof WellnessCheckQuestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WellnessCheckQuestion
     */
    wellnessCheckQuestion: string;
    /**
     * 
     * @type {string}
     * @memberof WellnessCheckQuestion
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof WellnessCheckQuestion
     */
    respondContent: string;
}

/**
 * Check if a given object implements the WellnessCheckQuestion interface.
 */
export function instanceOfWellnessCheckQuestion(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "wellnessCheckQuestion" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "respondContent" in value;

    return isInstance;
}

export function WellnessCheckQuestionFromJSON(json: any): WellnessCheckQuestion {
    return WellnessCheckQuestionFromJSONTyped(json, false);
}

export function WellnessCheckQuestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): WellnessCheckQuestion {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'wellnessCheckQuestion': json['wellnessCheckQuestion'],
        'category': json['category'],
        'respondContent': json['respondContent'],
    };
}

export function WellnessCheckQuestionToJSON(value?: WellnessCheckQuestion | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'wellnessCheckQuestion': value.wellnessCheckQuestion,
        'category': value.category,
        'respondContent': value.respondContent,
    };
}

